// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-confirmation/inventory-confirmation.less
// module id = 3457
// module chunks = 0